"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseV0Code = parseV0Code;
const Index_1 = require("../Index");
/**
 * Parse a V0 access code
 */
function parseV0Code(accessCode) {
    // Convert access code to integer
    const accessCodeInt = Number.parseInt(accessCode);
    if (isNaN(accessCodeInt))
        throw new Error('Access code is not an integer');
    // Extract version and length
    const accessCodeBinaryString = accessCodeInt.toString(2);
    const version = Number.parseInt(accessCodeBinaryString.slice(-2), 2);
    const length = Number.parseInt(accessCodeBinaryString.slice(-6, -2), 2) + 1;
    if (version != Index_1.AccessCodeVersion.V0)
        throw new Error('Invalid access code version');
    if (accessCode.length != length)
        throw new Error('Incorrect access code length');
    return {
        version: Index_1.AccessCodeVersion.V0,
        length,
    };
}
//# sourceMappingURL=V0.js.map